import { KeyboardEvent } from 'react';
import { Select, MenuItem, InputLabel, FormControl } from '@mui/material';
import { SelectProps } from '@mui/material/Select';

type BaseSelectProps = SelectProps & {
    options: Array<{ value: string; label: string }>;
    onKeyUp?: (e: KeyboardEvent<Element>) => void;
};

function BaseSelect({ label, options, onKeyUp, ...props }: BaseSelectProps) {
    return (
        <>
            <FormControl fullWidth>
                <InputLabel id="select-label">{label}</InputLabel>
                <Select labelId="select-label" label={label} onKeyUp={onKeyUp} {...props}>
                    {options.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </>
    );
}

export default BaseSelect;
